import Vue from 'vue';
var MyEntryList = require('./components/MyEntryList.vue').default;
var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Copier = require('../../lib/markers/copier.js');
var Tagger = require('../../lib/markers/tagger.js');
var Revealer = require('../../lib/revealer.js');
var Downloader = require('../../lib/markers/downloader.js');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

export default function() {
  const myEntryList = new Vue({
    el: '#my-entry-list',
    components: {
      'my-entry-list': MyEntryList
    }
  });

  $(document).one('pjax:end', () => {
    myEntryList.$destroy();
  });

  var marker = new Marker('entries');
  var revealer = new Revealer();

  new Deletism(marker);
  new Undeletism(marker);
  new Copier(marker);
  new Tagger(marker, revealer);
  new Downloader(marker);
  new Columnator();
  new IndexView();
}
